import { z } from 'zod';

/////////////////////////////////////////
// PERSONPERMISSIONS SCHEMA
/////////////////////////////////////////

export const personpermissionsSchema = z.object({
  permissionId: z.number().int(),
  personDepartmentId: z.number().int(),
  cityId: z.number().int(),
  personId: z.number().int(),
  departmentId: z.number().int(),
  classificationId: z.number().int(),
  CETopicId: z.number().int(),
  readOnly: z.number().int(),
  noReports: z.number().int(),
})

export type personpermissions = z.infer<typeof personpermissionsSchema>

export default personpermissionsSchema;
